import React from "react";
import {
  mdiAccountCircleOutline,
  mdiAccountSearch,
  mdiChevronDown,
  mdiCrownCircleOutline,
  mdiPlaylistEdit,
  mdiPower,
  mdiWrenchOutline,
} from "@mdi/js";
import Icon from "@mdi/react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { useAuth } from "../../Services/auth";
// import devDebug from "../Helpers/debug";
import { useComponentsStore } from "../../Stores/componentsStore";
import { useTenderStrategyStore } from "../../Stores/tenderStrategyStore";
import { useAuthStore } from "../../Stores/authStore";
import { isAdmin } from "../../Helpers/userRoles";
import i18n from "../../i18n";

export default function ProfileDropdown({ setMenu, menu, setShowUnsavedPopup, showUnsavedPopup }) {
  const { t } = useTranslation();
  const [isDark] = useComponentsStore((state) => [state.isDark]);
  const [user] = useAuthStore((state) => [state.user]);

  let auth = useAuth();
  const buildVademecumURL = (menuItem) => {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(menuItem?.params || {})) {
      if (value !== undefined && value !== null && value !== "") {
        params.set(key, value);
      }
    }

    const queryString = params.toString();
    return `/${i18n.language.slice(0, 2)}/vademecums${queryString ? `?${queryString}` : ""}`;
  };

  return (
    <Dropdown
      isOpen={menu}
      toggle={() => setMenu(!menu)}
      className="d-inline-block tc-fullscreen-margin-compensator cursor-pointer"
    >
      <DropdownToggle className="" id="page-header-user-dropdown" tag="div">
        {isAdmin(user) ? (
          <Icon
            path={mdiCrownCircleOutline}
            className=""
            title={t("Admin")}
            size={1}
            color={isDark ? "#8395cb" : "#292ba2"}
          />
        ) : (
          <Icon
            path={mdiAccountCircleOutline}
            className=""
            title={t("Admin")}
            size={1}
            color={isDark ? "#8395cb" : "#292ba2"}
          />
        )}
        <Icon
          path={mdiChevronDown}
          className="d-xl-inline-block profile_menu_chevron"
          title={t("Profile Dropdown Menu")}
          size={0.7}
        />
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu-end">
        <div className="dropdown-item tc-text-align-right pe-none">{useAuthStore.getState()?.user?.first_name}</div>
        <DropdownItem divider />
        {isAdmin(user) ? (
          <React.Fragment>
            <NavLink
              onClick={() => setMenu(!menu)}
              to={`/${i18n.language.slice(0, 2)}/admin/edit_tenders`}
              className="dropdown-item"
            >
              <Icon
                path={mdiPlaylistEdit}
                className="me-2 d-xl-inline-block profile_menu_settings_btn"
                title={t("Settings")}
                size={0.7}
              />
              {t("Edit Tenders")}
            </NavLink>
            <NavLink
              onClick={() => setMenu(!menu)}
              to={`/${i18n.language.slice(0, 2)}/admin/vademecum`}
              className="dropdown-item"
            >
              <Icon
                path={mdiPlaylistEdit}
                className="me-2 d-xl-inline-block profile_menu_settings_btn"
                title={t("Summary")}
                size={0.7}
              />
              {t("Summary")}
            </NavLink>
            <NavLink
              onClick={() => setMenu(!menu)}
              to={`/${i18n.language.slice(0, 2)}/admin/list_users`}
              className="dropdown-item"
            >
              <Icon
                path={mdiAccountSearch}
                className="me-2 d-xl-inline-block profile_menu_settings_btn"
                title={t("Settings")}
                size={0.7}
              />
              {t("List Users")}
            </NavLink>
          </React.Fragment>
        ) : null}
        {(user?.vademecum_menu_items || []).map((menuItem, idx) => (
          <NavLink
            key={menuItem?.key || `${menuItem?.label || "vademecum_menu_item"}_${idx}`}
            onClick={() => setMenu(!menu)}
            to={buildVademecumURL(menuItem)}
            className="dropdown-item"
          >
            <Icon
              path={mdiPlaylistEdit}
              className="me-2 d-xl-inline-block profile_menu_settings_btn"
              title={menuItem?.label || menuItem?.key || t("Summaries")}
              size={0.7}
            />
            {menuItem?.label || menuItem?.key || t("Summaries")}
          </NavLink>
        ))}
        <NavLink
          onClick={() => setMenu(!menu)}
          to={`/${i18n.language.slice(0, 2)}/user_preferences`}
          className="dropdown-item"
        >
          <Icon
            path={mdiWrenchOutline}
            className="me-2 d-xl-inline-block profile_menu_settings_btn"
            title={t("Settings")}
            size={0.7}
          />
          {t("Settings")}
        </NavLink>
        <div
          className="cursor-pointer dropdown-item profile_menu_logout_btn"
          onClick={() => {
            if (useTenderStrategyStore.getState().unsavedWarning === 1) {
              setShowUnsavedPopup(!showUnsavedPopup);
            } else {
              auth.signout(() => {
                navigate(`/${i18n.language.slice(0, 2)}/`);
                setTimeout(() => {
                  useAuthStore.getState().setStrategiesNeverRequested(true);
                  useTenderStrategyStore.getState().setStrategiesStatus("loading");
                }, [100]);
              });
            }
          }}
        >
          <Icon
            path={mdiPower}
            className="me-2 d-xl-inline-block cursor-pointer"
            title={t("Logout")}
            size={0.7}
            color="#f46a69"
          />
          <span>{t("Logout")}</span>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
}
